import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Holerite, PerfilImportacao } from '../models/holerite.model';

export type FormatoRemessaHolerite = 'cnab200' | 'cnab400';
export interface ValidacaoRemessaHolerite {
  valido: boolean;
  formato: FormatoRemessaHolerite;
  nomeArquivo: string;
  tamanhoRegistro: number;
  quantidadeHolerites: number;
  quantidadeRegistros: number;
  totalCreditos: string;
  totalDebitos: string;
  totalLiquido: string;
  avisos: string[];
  erros: string[];
  assinatura: string;
}
export interface RequisicaoRemessaHolerite {
  formato: FormatoRemessaHolerite;
  configuracao: Record<string, string>;
  documentosIds: string[];
  assinatura?: string;
}

@Injectable({ providedIn: 'root' })
export class HoleritesService {
  private readonly apiUrl = '/api/sankhya/holerites';

  constructor(private readonly http: HttpClient) {}

  listarPerfis(empresa: string): Observable<PerfilImportacao[]> {
    return this.http.get<PerfilImportacao[]>(`${this.apiUrl}/perfis`, { params: this.params(empresa) });
  }

  salvarPerfil(empresa: string, perfil: PerfilImportacao): Observable<PerfilImportacao> {
    return this.http.post<PerfilImportacao>(`${this.apiUrl}/perfis`, perfil, { params: this.params(empresa) });
  }

  excluirPerfil(empresa: string, id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/perfis/${encodeURIComponent(id)}`, { params: this.params(empresa) });
  }

  listarDocumentos(empresa: string): Observable<Holerite[]> {
    return this.http.get<Holerite[]>(`${this.apiUrl}/documentos`, { params: this.params(empresa) });
  }

  salvarDocumento(empresa: string, holerite: Holerite): Observable<Holerite> {
    return this.http.post<Holerite>(`${this.apiUrl}/documentos`, holerite, { params: this.params(empresa) });
  }

  excluirDocumento(empresa: string, id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/documentos/${encodeURIComponent(id)}`, { params: this.params(empresa) });
  }

  validarRemessa(empresa: string, requisicao: RequisicaoRemessaHolerite): Observable<ValidacaoRemessaHolerite> {
    return this.http.post<ValidacaoRemessaHolerite>(`${this.apiUrl}/remessas/validar`, requisicao, { params: this.params(empresa) });
  }

  gerarRemessa(empresa: string, requisicao: RequisicaoRemessaHolerite): Observable<HttpResponse<Blob>> {
    return this.http.post(`${this.apiUrl}/remessas/gerar`, requisicao, { params: this.params(empresa), observe: 'response', responseType: 'blob' });
  }

  private params(empresa: string): HttpParams {
    return new HttpParams().set('empresa', empresa);
  }
}
